/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AiType } from '@squiz/dxp-ai-types';

export const getAiContextPath = (type: `${AiType}`, aiId: string, contextId: string): string => {
  const basePath = type === AiType.chatbot ? 'ai-chatbots' : 'ai-content-tool';

  // Used for router
  return `/${basePath}/${aiId}/contexts/${contextId}`;
};
